import { useState, useEffect } from 'react';
import { authConnect } from 'utils/API/Merchant APIs/UpdatedAPIs/AuthUpdatedAPICall';
import { globalNotifyError } from 'views/utilities/AlertToast';
import { Navigate } from 'react-router-dom';

export const useAuthConnect = () => {
    const [response, setResponse] = useState(null);
    const authToken = localStorage.getItem('AuthToken');

    useEffect(() => {
        const fetchAuth = async () => {
            try {
                if (!authToken) {
                    const res = await authConnect();
                    // console.log('res', res);

                    if (res?.status === 200) {
                        const { token, user } = res?.data?.Response?.data || {};
                        if (token && user) {
                            localStorage.setItem('AuthToken', token);
                            localStorage.setItem('userDetails', JSON.stringify(user));
                            setResponse(res);
                        }
                    }
                } else {
                    console.log('AuthToken already exists:', authToken);
                }
            } catch (err) {
                <Navigate to="/unauthorized-section" replace />;
                // setError(err);
                globalNotifyError(err);
            }
        };
        fetchAuth();
    });

    return response;
};
